/**
 * Normalize notification action URLs to valid in-app routes.
 * Legacy notifications may contain old root paths (e.g. /optimize, /wfa).
 */
export function getNotificationNavigationTarget(actionUrl?: string): string | null {
  if (!actionUrl) {
    return null;
  }

  const raw = actionUrl.trim();
  if (!raw) {
    return null;
  }

  // Preserve known valid app routes.
  if (raw.startsWith('/app')) {
    return raw;
  }

  // Legacy routes that no longer exist at root level.
  if (raw.startsWith('/optimize') || raw.startsWith('/wfa') || raw.startsWith('/backtest')) {
    return '/app';
  }

  // Known account pages now live under /app.
  if (raw.startsWith('/profile')) {
    return '/app/profile';
  }
  if (raw.startsWith('/billing')) {
    return '/app/billing';
  }
  if (raw.startsWith('/support')) {
    return '/app/support';
  }

  // Any unknown internal path falls back to the app landing screen.
  if (raw.startsWith('/')) {
    return '/app';
  }

  return '/app';
}
